export default __webpack_public_path__ + "img/m2.asset.fac8ab01.png";